var Utility = /** @class */ (function () {
    function Utility() {
    }
    Utility.isStringNullOrUndefinedOrEmpty = function (stringa) {
        return stringa === null || stringa === undefined || stringa === '';
    };
    Utility.prototype.arrotondamentoADueCifreDecimali = function (x) {
        return Number.parseFloat(x).toPrecision(2);
    };
    return Utility;
}());
export { Utility };
//# sourceMappingURL=utility.js.map